import { Component, Input, inject } from '@angular/core';
import { Currency, CurrentEarnRate, zeroPadNumberForDisplay, CurrencyAmountComponent } from 'core';
import { BsModalService } from 'ngx-bootstrap/modal';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-earn-bonus-tiers',
  templateUrl: 'earn-bonus-tiers.component.html',
  styleUrls: ['earn-bonus-tiers.scss'],
  imports: [RouterLink, CurrencyAmountComponent],
})
export class EarnBonusTiersComponent {
  private modalService = inject(BsModalService);

  zeroPadNumberForDisplay = zeroPadNumberForDisplay;

  @Input() rate: CurrentEarnRate;
  @Input() zoomCurrency: Currency;
  @Input() fullKyc: boolean;

  hideModal(): void {
    this.modalService.hide();
  }
}
